import { LandingFooter } from '../LandingFooter/LandingFooter'
import {
  useMarketingFooterNavigation,
  type UseMarketingFooterNavigationOptions,
} from '../../../src/landing/hooks/useMarketingFooterNavigation'

type MarketingPageFooterProps = UseMarketingFooterNavigationOptions

export function MarketingPageFooter({ contactMode }: MarketingPageFooterProps) {
  const footerNav = useMarketingFooterNavigation({ contactMode })
  return <LandingFooter {...footerNav} />
}
